import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import type { TableConfig } from '../../types';
import { type ConfigUpdate, InitAction, SetConfigAction, SetDataAction } from './actions';
import useDispatch from './dispatch';
import reducer, { getInitialState } from './reducer';
import { ResizeContextProvider } from './ResizeContext';
import Store from './Store';
const {
  Provider
} = Store;
function UpdateFromChanges(props) {
  const $ = _c(8);
  const {
    data,
    config
  } = props;
  const dispatch = useDispatch();
  let t0;
  let t1;
  if ($[0] !== data || $[1] !== dispatch) {
    t0 = () => {
      dispatch(new SetDataAction(data));
    };
    t1 = [data, dispatch];
    $[0] = data;
    $[1] = dispatch;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
  let t2;
  let t3;
  if ($[4] !== config || $[5] !== dispatch) {
    t2 = () => {
      dispatch(new SetConfigAction(config));
    };
    t3 = [config, dispatch];
    $[4] = config;
    $[5] = dispatch;
    $[6] = t2;
    $[7] = t3;
  } else {
    t2 = $[6];
    t3 = $[7];
  }
  useEffect(t2, t3);
  return null;
}
function TableStoreProvider(t0) {
  const $ = _c(11);
  const {
    children,
    data,
    config,
    tableRef
  } = t0;
  let t1;
  let t2;
  if ($[0] !== config || $[1] !== data) {
    t1 = () => reducer(getInitialState(), new InitAction({
      data,
      config
    }));
    t2 = <UpdateFromChanges data={data} config={config} />;
    $[0] = config;
    $[1] = data;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  let t3;
  if ($[4] !== children || $[5] !== tableRef) {
    t3 = <ResizeContextProvider tableRef={tableRef}>{children}</ResizeContextProvider>;
    $[4] = children;
    $[5] = tableRef;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t1 || $[8] !== t2 || $[9] !== t3) {
    t4 = <Provider getInitialState={t1}>{t2}{t3}</Provider>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}
export default TableStoreProvider;